import { IEntity } from '../interfaces/entity';
import { AssessmentTemplate } from './assessment-template';
import { Review } from './review';
import { AssessmentType } from './assessment-type';
import { User } from './user';

export interface IAssessmentList{
  items: Assessment[];
  totalCount: number;
}

export class Assessment implements IEntity {
  id: number;
  uid: string;
  assessmentTemplateId: number;
  assessmentTemplate: AssessmentTemplate;
  score: number;
  acceptanceThreshold: number;
  completed: boolean;
  completedDate: string;
  completedById: number;
  completedBy: User;
  reviewId: number;
  review: Review;
  lastModifiedDate: string;
  assessmentAssessmentTypeLinks: AssessmentAssessmentTypeLink[];
  canDelete: boolean;

  constructor(assessment?){
    assessment = assessment || {};
    this.id = assessment.id;
    this.uid = assessment.uid;
    this.assessmentTemplateId = assessment.assessmentTemplateId;
    this.assessmentTemplate = assessment.assessmentTemplate;
    this.score = assessment.score;
    this.acceptanceThreshold = assessment.acceptanceThreshold;
    this.completed = assessment.completed || false;
    this.completedDate = assessment.completedDate;
    this.completedById = assessment.completedById;
    this.completedBy = assessment.completedBy;
    this.lastModifiedDate = assessment.lastModifiedDate;
    this.reviewId = assessment.reviewId;
    this.review = assessment.review;
    this.assessmentAssessmentTypeLinks = assessment.assessmentAssessmentTypeLinks || [];
    this.canDelete = assessment.canDelete;
  }
}

// tslint:disable-next-line: max-classes-per-file
export class AssessmentAssessmentTypeLink {
  id: number;
  assessmentId: number;
  assessment: Assessment;
  assessmentTypeId: number;
  assessmentType: AssessmentType;

  constructor(link?){
    link = link || {};
    this.id = link.id;
    this.assessmentId = link.assessmentId;
    this.assessment = link.assessment;
    this.assessmentTypeId = link.assessmentTypeId;
    this.assessmentType = link.assessmentType;
  }
}
